/* 🤖 this file was generated by svg-to-ts */
export const siriusGlobeStand: {
  name: 'globe_stand';
  data: string;
} = {
  name: 'globe_stand',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M6.39 2.64a.75.75 0 0 0-1.061-1.061A10.495 10.495 0 0 0 12 19.468V21H9.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H13.5v-1.532c2.51-.18 4.88-1.256 6.671-3.047a.75.75 0 0 0-1.06-1.06A8.995 8.995 0 0 1 6.39 2.64Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm-6 7.5a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z" fill="currentColor"/></svg>`
};
